import React from "react";

import { hideLoadingScreen } from "@/modules/loading";

import img_maintenance from "@/assets/img/img_maintenance.png";
import img_maintenance_wrench from "@/assets/img/img_maintenance_wrench.gif";

import img_maintenance_v1 from "@/assets/img/img_maintenance_v1.png";
import img_maintenance_v1_screen from "@/assets/img/img_maintenance_v1_screen.gif";

import "@/assets/fonts/sl-fonts/style.css";
import "@/index.scss";
import "@/scrollbars.scss";
import "./index.scss";

interface IProps {
	match?: any;
}

export default class MaintenancePage extends React.Component<IProps> {
	componentDidMount() {
		hideLoadingScreen();
	}
	
	render() {
		switch (this.props.match.params.version) {
			case "0":
				return (
					<div className="maintenance-page">
						<img src={img_maintenance} className="background" alt="bg" />
						<img src={img_maintenance_wrench} className="wrench" alt="wrench" />
					</div>
				);
				
			default:
				return (
					<div className="maintenance-page v1">
						<img src={img_maintenance_v1} className="background" alt="bg" />
						<img src={img_maintenance_v1_screen} className="wrench" alt="screen" />
					</div>
				);
		}
	}
}